import { render } from "./IndexExitDeclarationStatusPage.vue?vue&type=template&id=2598a5df"
import script from "./IndexExitDeclarationStatusPage.vue?vue&type=script&lang=js"
export * from "./IndexExitDeclarationStatusPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__